import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="4.93mm"
    height={25.701}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 493000 680010"
    {...props}
  >
    <path
      d="M17580 229960C25570 115980 117620 24630 231690 17480c64210-4020 125230 17890 171890 61720 46710 43850 72420 103280 72420 167310 0 74900-36710 145270-98210 188240-28650 20020-45890 53080-46280 88630H161500c-400-35320-18030-68650-47320-89360-66170-46770-102280-123050-96600-204060zm313920 331090-170000-40v-20630h170000v20670zm0 37630-170000-40v-20630l170000 40v20630zm0 20630c0 4550-1770 8820-4980 12030s-7480 4970-12020 4970l-136000-30c-9370 0-17000-7630-17000-17000v-3640l170000 40v3630zm-55980 38720c-3210 3210-7480 4980-12010 4980l-34020-40c-6750 0-12590-3960-15330-9680l64710 20c-830 1730-1950 3330-3350 4720zM104360 447900c25130 17770 40140 46450 40140 76720v94660c0 18740 15250 34000 33990 34000h17800c3360 15250 16970 26690 33200 26690l34010 40c9080 0 17620-3540 24040-9960 4670-4660 7810-10440 9180-16740h17780c9080 0 17620-3530 24040-9950s9960-14960 9960-24050v-94700c0-30470 14600-58850 39030-75930 66040-46140 105470-121720 105470-202170 0-67780-28350-133280-77780-179700C365110 19730 299570-3790 230620 510 108080 8200 9210 106330 630 228770c-6100 86980 32680 168900 103730 219130z"
      style={{
        fill: "#1c1c1d",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
